export default function Support() {
  return (
    <div style={{ padding: "8%" }}>
      <center>
        <h1 style={{ color: "#7BAFD4" }}>Support</h1>
        <p>
          For help understanding how to take the survey and interpret survey
          results please refer to the <a href="https://www.med.unc.edu/transition/about-us-1/">STARx Program Home Page</a>
        </p>
        <br></br>
        <p>
          For technical support or support using the application please reach
          out to our developer team at xhn20001106@gmail.com
        </p>
      </center>
    </div>
  );
}
